import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=1283c0c8&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=1283c0c8&scoped=true&lang=css&"
import style1 from "./Breadcrumbs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1283c0c8",
  null
  
)

component.options.__file = "Breadcrumbs.vue"
export default component.exports